import { identity } from 'lodash'

import selectors from '../selectors'
import { SHOW_MESSAGE, SHOW_TOAST_NOTIFICATION, DISMISS_MESSAGE } from '../constants/ActionTypes'

const { timeoutSelector } = selectors(identity)

/**
 * @typedef {import('../index').Dispatch} Dispatch
 * @typedef {import('../index').GetState} GetState
 */

/**
 * @typedef {ReturnType<typeof showToastNotification> | ReturnType<typeof _showMessage> | ReturnType<typeof dismissMessage>} NotificationsActions
 */

/**
 * @param {boolean} visible
 * @param {'duplicate' | 'move' | Null} cardAction
 * @param {number | 'series' | null} newBookId
 * @param {'move' | Null} lineAction
 * @return {{ type: 'SHOW_TOAST_NOTIFICATION', visible: boolean, cardAction: 'duplicate' | 'move' | Null, newBookId: number | 'series' | Null, lineAction: 'move' | Null }}
 */
export function showToastNotification(visible, cardAction, newBookId, lineAction) {
  return { type: SHOW_TOAST_NOTIFICATION, visible, cardAction, newBookId, lineAction }
}

/**
 * @param {String} message
 * @param {ReturnType<typeof setTimeout>} timeout
 * @return {{ type: 'SHOW_MESSAGE', message: String, timeout: ReturnType<typeof setTimeout> }}
 */
export const _showMessage = (message, timeout) => {
  return { type: SHOW_MESSAGE, message, timeout }
}

/**
 * @param {String} message
 * @return {function(Dispatch, GetState): Void}
 */
export const showMessage = (message) => (dispatch, getState) => {
  const state = getState()
  const existingTimeout = timeoutSelector(state)

  if (existingTimeout) {
    clearTimeout(existingTimeout)
  }

  const timeout = setTimeout(() => {
    dispatch(dismissMessage())
  }, 5000)
  dispatch(_showMessage(message, timeout))
}

/**
 * @return {{ type: 'DISMISS_MESSAGE' }}
 */
export function dismissMessage() {
  return { type: DISMISS_MESSAGE }
}
